import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/components/shared-components/class/general-classes/app-settings';
import { iMedia } from 'src/model/interface/iMedia';
import { EventService } from './event.service';
import { tap } from "rxjs/operators";
import { AnimationKeyframesSequenceMetadata } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class GatewayKnxService {

  constructor(private _http: HttpClient,
    private _eventService: EventService) { }

  /**
   * Import the ETS proj
   * @param ETSProjToUpload file to upload
   * @param InstanceGUID instanceguid of KNX to use for the import
   * @param ProjPassword project password (if present)
   * @param NumberOfCharForRoomNumber number of last chars of room name to use as room number (if 0 = take from last space)
   * @returns 
   */
  public ImportETSProj(ETSProjToUpload: any, InstanceGUID: string, ProjPassword: string, NumberOfCharForRoomNumber: number): Promise<any> {

    let formData = new FormData();
    formData.append("etsproj", ETSProjToUpload, ETSProjToUpload.name);
    formData.append("password", ProjPassword);
    formData.append("roomcharnumber", NumberOfCharForRoomNumber.toString());
    formData.append("instanceguid", InstanceGUID);

    return this._http
      .post<any>(
        environment.httpServerRoot + AppSettings.API_URL_GATEWAY_KNX_IMPORT,
        formData,
        {
          reportProgress: true,
          observe: "events",
        }
      )
      .pipe(
        tap((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            const percenteUploaded: number = Math.round(
              (100 * event.loaded) / event.total
            );
            this._eventService.OnETSImportInProgressEvent.next(
              percenteUploaded
            );
          } else if (event.type === HttpEventType.Response) {
            const mediaUploaded: iMedia = event.body;

            this._eventService.OnETSImportComplete.next(mediaUploaded);
          } else if (event.type === HttpEventType.Sent) {
            this._eventService.OnETSImportInProgressEvent.next(0);
          } else {
            /** If object emit with status different to 200, something went wrong */
            if (event.status && event.status !== 200) {
              this._eventService.OnETSImportAbort.next(null);
            }
          }
        })
      )
      .toPromise();
  }

}
